import {defineStore} from "pinia";
import {ref} from "vue";
import {Holiday, OfficeLocation} from "@/types/DataTypes.ts";
import {peopleBackend} from "@/backend/people.backend.ts";
import {adminBackend} from "@/backend/admin.backend.ts";

export const useHolidaysStore
    = defineStore('holidays', () => {
    const holidays = ref([] as Holiday[]);

    peopleBackend.holidays().then((data) => {
        holidays.value = data;
    })

    const locations = ref(Object.values(OfficeLocation));

    async function addHolidays(newHolidays: Holiday[]) {
        console.log("Adding holidays", newHolidays);
        holidays.value = await adminBackend.addHolidays(newHolidays);
    }

    async function copyHolidaysFromPreviousYear(year: number) {
        holidays.value = await adminBackend.copyHolidaysFromPreviousYear(year);
    }

    async function updateHolidayDate(id: number, date: string) {
        holidays.value = await adminBackend.updateHoliday(id, { date });
    }

    function forLocation(location: OfficeLocation) {
        return holidays.value.filter(holiday => holiday.location === location);
    }

    return {
        holidays, locations, addHolidays, copyHolidaysFromPreviousYear, updateHolidayDate, forLocation
    }
});